export default `
<div>
  <div class="academy-course">
    <academy-course course="course" user="currentUser"></academy-course>
  </div>
</div>
`;
